export default __webpack_public_path__ + "static/media/ic_copy_16.da7c4d62.svg";